(function ($) {

    console.log(ajax_object);
    // skjule tømmekalender
  $(".close-kalender").on("click", function (e) {
    $(".tommekalender-dates-wrapper").hide();
  });

  $(document).on("keydown", function (e) {
    if (e.keyCode === 27) {
      // ESC
      $(".tommekalender-dates-wrapper").hide();
    }
  });

  // sortere
  $(".sortere-form").submit(function (e) {
    e.preventDefault();
    var term = $(this).find("#sortere").val();
    var url = "https://sortere.no/";
    window.open(url, "_blank");
  });
  // Tømmekalender
  var currentRequest = null;
  var tommekalender_results_item_selected = false;
  var tommekalender_obj;

  if ($(".tommekalender-form").length) {
    // $("#tommekalender-input").focus();
    $(".tommekalender-form").submit(function (e) {
      e.preventDefault();
      return false;
    });

    $("#tommekalender-input")
      .on("input", function () {
        tommekalender_results_item_selected = false;

        if ($(this).val() != "") {
          check_results();
        } else {
          tommekalender_obj = null;
          if (currentRequest != null) {
            currentRequest.abort();
          }
          clearResults();
          hideHint();
          hideError();
        }
      })
      .on("focus", function () {
        if ($(this).val() != "") {
          showResults();
        }
        // $(this).val("");
        // clearResults();
        // showResults();
      })
      .on("blur", function (e) {
        // $(".tommekalender-results").hide();
      })
      .keydown(function (e) {
        if ($(".tommekalender-results a.active").length && e.which == 39) {
          return;
        }
        switch (e.which) {
          case 38: // up
            selectStreet("up");
            e.preventDefault();
            break;

          case 40: // down
          case 39: // right
            // case 9: // right
            selectStreet("down");
            e.preventDefault();
            break;

          case 13: // enter
            $(this).blur();
            getCalendarResults();
            clearResults();
            e.preventDefault();
            break;

          default:
            return; // exit this handler for other keys
        }
      });
    $(document).mouseup(function (e) {
      var container = $(".tommekalender-form-wrapper");

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        clearResults();
      }
    });

    function check_results() {
      var tommekalender_input = $("#tommekalender-input");

      if (
        tommekalender_input.val()[tommekalender_input.val().length - 1] == ","
      ) {
        tommekalender_input.val(tommekalender_input.val() + " ");
      }
      $(".tommekalender-results").html("");
      showResults();
      $(".tommekalender-results-wrapper .loading").show();
      hideHint();
      updateFormData("", "", "", "", "");
      var data = {
        action: "get_addresses",
        security: ajax_object.ajax_nonce,
        tommekalender_search: tommekalender_input.val(),
      };

      currentRequest = jQuery
        .ajax({
          type: "POST",
          data: data,
          url: ajax_object.ajax_url,
          cache: false,
          beforeSend: function () {
            if (currentRequest != null) {
              currentRequest.abort();
            }
          },
        })
        .done(function (response) {
          $(".tommekalender-results-wrapper .loading").hide();
          if (response === "false") {
            showError(true);
          } else {
            var input_val = $("#tommekalender-input").val();
            tommekalender_obj = JSON.parse(response);
            $(".tommekalender-results").html("");
            if (tommekalender_obj.length > 0) {
              for (var item in tommekalender_obj) {
                if (tommekalender_obj[item].type == "matrikkelenhet") {
                  tommekalender_item = $(
                    '<a href="#" data-kommunenummeret="' +
                      tommekalender_obj[item].kommunenummeret +
                      '" data-address="' +
                      tommekalender_obj[item].address +
                      '" data-cadastre-number="' +
                      tommekalender_obj[item].cadastre_number +
                      '" data-type="' +
                      tommekalender_obj[item].type +
                      '" data-number="' +
                      tommekalender_obj[item].number +
                      '">' +
                      tommekalender_obj[item].cadastre_number +
                      ", " +
                      tommekalender_obj[item].address +
                      "</a>"
                  );
                  $(".tommekalender-results").append(tommekalender_item);
                } else {
                  tommekalender_item = $(
                    '<a href="#" data-kommunenummeret="' +
                      tommekalender_obj[item].kommunenummeret +
                      '" data-address="' +
                      tommekalender_obj[item].address +
                      '" data-cadastre="' +
                      tommekalender_obj[item].cadastre_number +
                      '" data-type="' +
                      tommekalender_obj[item].type +
                      '" data-number="' +
                      tommekalender_obj[item].number +
                      '">' +
                      tommekalender_obj[item].address_full +
                      "</a>"
                  );
                  $(".tommekalender-results").append(tommekalender_item);
                }
              }

              if (
                input_val ==
                  tommekalender_obj[0].address +
                    " " +
                    tommekalender_obj[0].number ||
                input_val ==
                  tommekalender_obj[0].cadastre_number +
                    ", " +
                    tommekalender_obj[0].address
              ) {
                updateFormData(
                  tommekalender_obj[0].kommunenummeret,
                  tommekalender_obj[0].address,
                  tommekalender_obj[0].number,
                  tommekalender_obj[0].type,
                  tommekalender_obj[0].cadastre_number
                );
                $("#tommekalender-form-button")
                  .removeClass("disabled")
                  .prop("disabled", false);
              }
              if (tommekalender_obj.length == 1) {
                selectStreet("down");
              }

              if (tommekalender_obj[item].type == "matrikkelenhet") {
                var hint =
                  tommekalender_obj[0].cadastre_number +
                  ", " +
                  tommekalender_obj[0].address;
              } else {
                var hint =
                  tommekalender_obj[0].address +
                  " " +
                  tommekalender_obj[0].number;
              }
              $(".sortere-input-hint").html(hint);
              $("#tommekalender-input").val(
                hint.substring(0, $("#tommekalender-input").val().length)
              );
              showResults();
            } else {
              clearResults();
              showError();
            }
          }
        });
    }

    function clearResults() {
      // $(".tommekalender-results").html("");
      $(".tommekalender-results-wrapper").hide();
      $(".tommekalender-results-error").hide();
      $("#tommekalender-input").removeClass("active");
      hideHint();
    }
    function showResults() {
      hideError();
      $(".tommekalender-results-wrapper").show();
      $("#tommekalender-input").addClass("active");
    }
    function showError(apiError = false) {
      console.log("asd");
      if (apiError) {
        $(".tommekalender-results-error-api").show();
      } else {
        $(".tommekalender-results-error").show();
      }
      $("#tommekalender-input").addClass("active");
      $(".tommekalender-dates-wrapper h2.tommekalender-dates-title").html("");
      $(".tommekalender-dates-wrapper .tommekalender-dates").html("");
    }
    function hideError() {
      $(".tommekalender-results-error").hide();
      $(".tommekalender-results-error-api").hide();
      $("#tommekalender-input").removeClass("active");
    }
    function hideHint() {
      $(".sortere-input-hint").html("");
    }

    function selectStreet(direction) {
      hideHint();
      var tommekalender_results_items_nm = $(".tommekalender-results a").length;
      if (tommekalender_results_items_nm) {
        if (direction == "down") {
          if (tommekalender_results_item_selected === false) {
            tommekalender_results_item_selected = 1;
          } else {
            tommekalender_results_item_selected++;
          }
          if (
            tommekalender_results_item_selected > tommekalender_results_items_nm
          ) {
            tommekalender_results_item_selected = 1;
          }
        } else {
          if (tommekalender_results_item_selected === false) {
            tommekalender_results_item_selected =
              tommekalender_results_items_nm;
          } else {
            tommekalender_results_item_selected--;
          }
          if (tommekalender_results_item_selected < 1) {
            tommekalender_results_item_selected =
              tommekalender_results_items_nm;
          }
        }
        $(".tommekalender-results a.active").removeClass("active");
        $selected_item = $(
          ".tommekalender-results a:nth-child(" +
            tommekalender_results_item_selected +
            ")"
        );
        $selected_item.addClass("active");
        if ($selected_item.data("type") == "matrikkelenhet") {
          $("#tommekalender-input").val(
            $selected_item.data("cadastre-number") +
              ", " +
              $selected_item.data("address")
          );
        } else {
          $("#tommekalender-input").val(
            $selected_item.data("address") + " " + $selected_item.data("number")
          );
        }
        updateFormData(
          $selected_item.data("kommunenummeret"),
          $selected_item.data("address"),
          $selected_item.data("number"),
          $selected_item.data("type"),
          $selected_item.data("cadastre-number")
        );
      }
    }

    $(".tommekalender-results").on("click", "a", function (e) {
      e.preventDefault();
      if ($(this).data("type") == "matrikkelenhet") {
        $("#tommekalender-input").val(
          $(this).data("cadastre-number") + ", " + $(this).data("address")
        );
      } else {
        $("#tommekalender-input").val(
          $(this).data("address") + " " + $(this).data("number")
        );
      }
      updateFormData(
        $(this).data("kommunenummeret"),
        $(this).data("address"),
        $(this).data("number"),
        $(this).data("type"),
        $(this).data("cadastre-number")
      );
      getCalendarResults();
      clearResults();
    });

    function updateFormData(
      kommunenummeret,
      address,
      number,
      type,
      cadastre_number
    ) {
      $("#tommekalender-kommunenummeret").val(kommunenummeret);
      $("#tommekalender-address").val(address);
      $("#tommekalender-number").val(number);
      $("#tommekalender-type").val(type);
      $("#tommekalender-cadastre-number").val(cadastre_number);
      if (
        $("#tommekalender-kommunenummeret").val() &&
        $("#tommekalender-address").val() &&
        ($("#tommekalender-number").val() ||
          $("#tommekalender-cadastre-number").val())
      ) {
        $("#tommekalender-form-button")
          .removeClass("disabled")
          .prop("disabled", false);
      } else {
        $("#tommekalender-form-button")
          .addClass("disabled")
          .attr("disabled", "disabled");
      }
    }

    $("#tommekalender-form-button").click(function () {
      getCalendarResults();
      clearResults();
    });

    function getCalendarResults() {
      if (
        $("#tommekalender-kommunenummeret").val() &&
        $("#tommekalender-address").val() &&
        ($("#tommekalender-number").val() ||
          $("#tommekalender-cadastre-number").val())
      ) {
        $(".tommekalender-dates").html("");
        $(".tommekalender-dates-wrapper h2.tommekalender-title1").html("");
        $(".tommekalender-dates-wrapper h2.tommekalender-dates-title").html("");
        // $(".close-kalender").hide();
        $(".tommekalender-app-info").hide();
        $(".tommekalender-sms-wrapper").hide();
        $(".tommekalender-dates-wrapper").show();
        $(".tommekalender-dates-loading").show();
        scrollTo($("#tommekalender-dates"));
        var data = {
          action: "tommekalender",
          security: ajax_object.ajax_nonce,
          tommekalender_kommunenummeret: $(
            "#tommekalender-kommunenummeret"
          ).val(),
          tommekalender_address: $("#tommekalender-address").val(),
          tommekalender_number: $("#tommekalender-number").val(),
          tommekalender_type: $("#tommekalender-type").val(),
          tommekalender_cadastre_number: $(
            "#tommekalender-cadastre-number"
          ).val(),
        };

        if (data.tommekalender_type == "matrikkelenhet") {
          $("#tommekalender-input").val(
            data.tommekalender_cadastre_number +
              ", " +
              data.tommekalender_address
          );
        } else {
          $("#tommekalender-input").val(
            data.tommekalender_address + " " + data.tommekalender_number
          );
        }

        var tommekalenderxhr = jQuery
          .post(ajax_object.ajax_url, data, function (response) {
            if (response === "false") {
              console.log("tommekalenderxhr false");
              getCalendarResultsError();
            } else {
              tommekalender_obj = JSON.parse(response);
              console.log(tommekalender_obj);
              if (data.tommekalender_type == "matrikkelenhet") {
                $(
                  ".tommekalender-dates-wrapper h2.tommekalender-dates-title"
                ).html(
                  data.tommekalender_cadastre_number +
                    ", " +
                    data.tommekalender_address
                );
              } else {
                $(".tommekalender-dates-wrapper h2.tommekalender-title1").html(
                  "Her ser du når ditt avfall blir hentet i:"
                );
                $(
                  ".tommekalender-dates-wrapper h2.tommekalender-dates-title"
                ).html(
                  data.tommekalender_address + " " + data.tommekalender_number
                );
              }
              var tommekalender_obj_data = tommekalender_obj["data"];
              var tommekalender_obj_pdf = tommekalender_obj["pdf"];
              if (tommekalender_obj_data == null || tommekalender_obj_data.length == 0) {
                $(".close-kalender").show();
                $(".tommekalender-app-info").hide();
                $(".tommekalender-sms-wrapper").hide();
                var html = '<div class="row justify-content-center">';
                html +=
                  "Denne eiendommen er ikke tilknyttet noen fast rute for innsamling av avfall";
                html += "</div>";
                $(".tommekalender-dates").html(html);
              } else {
                $(".close-kalender").show();
                $(".tommekalender-app-info").show();
                $(".tommekalender-sms-wrapper").show();
                var html = '<div class="tommekalender-items">';

                console.log(fraksjoner_arr);

                for (var item in tommekalender_obj_data) {
                  html += '<div class="tommekalender-item">';
                  html +=
                    '<div class="tommekalender-item-img"><img src="' +
                    fraksjoner_arr[tommekalender_obj_data[item].fraksjonId]
                      .norkartStandardFraksjonIkon +
                    '" alt=""></div>';
                  html += '<div class="tommekalender-item-dates">';
                  html +=
                    "<p><strong>" +
                    fraksjoner_arr[tommekalender_obj_data[item].fraksjonId]
                      .Navn +
                    "</strong></p>";
                  for (var date in tommekalender_obj_data[item].tommedatoer) {
                    html +=
                      '<div class="tommekalender-item-date">' +
                      tommekalender_obj_data[item].tommedatoer[date] +
                      "</div>";
                  }
                  html += "</div>";
                  html += "</div>";
                }
                html += "</div>";

                var pdf = '<div class="tommekalender-item-buttons">';
                pdf += '<p>Endringar kan skje på grunn av heilagdagar, omlegging av ruter, eller på stutt varsel på grunn av sjukdom, vær eller anna.</p>'
                if (tommekalender_obj_pdf == "disabled") {
                  pdf +=
                    '<div class="tommekalender-item-button"><a href="#" target="_blank" class="btn btn-primary disabled">Last ned tømmekalender - 2020 (PDF)</a><br><small>Oppdatering av tømmekalender for 2.halvår pågår, og vil være tilgjengelig fra 1.juni.<br><a href="https://www.fias.no/kundeservice/">Kontakt FIAS</a> for å få tilsendt tømmekalender for 1.halvår</small></div>';
                } else {
                  for (i = 0; i < tommekalender_obj_pdf.length; i++) {
                    if (i == 0) {
                      pdf +=
                        '<div class="tommekalender-item-button"><a href="' +
                        tommekalender_obj_pdf[i]["file"] +
                        '" target="_blank" class="btn btn-primary">Last ned tømmekalender  ' +
                        tommekalender_obj_pdf[i]["year"] +
                        " </a></div>";
                    } else {
                      pdf +=
                        '<div class="tommekalender-item-button"><a href="' +
                        tommekalender_obj_pdf[i]["file"] +
                        '" target="_blank" class="btn btn-primary">Last ned tømmekalender  ' +
                        tommekalender_obj_pdf[i]["year"] +
                        " </a></div>";
                    }
                  }
                }
                pdf += "</div>";
                $(".tommekalender-dates").html(html).append(pdf);
              }
              $(".tommekalender-dates-wrapper").fadeIn();

              $(".tommekalender-dates-loading").hide();

              $("#tommekalender-sms").show();
              $("#tommekalender-sms-message").hide();
              $("#tommekalender-sms-error").hide();
              $("#tommekalender-sms-mobilnummer").val("");
              $("#tommekalender-sms-time").val("");
            }
          })
          .fail(function () {
            console.log("tommekalenderxhr fail");
            getCalendarResultsError();
          });
      }
    }
    function getCalendarResultsError() {
      $(".tommekalender-app-info").hide();
      $(".tommekalender-sms-wrapper").hide();
      $(".tommekalender-dates-loading").hide();
      var html = '<div class="row justify-content-center">';
      html +=
        "Tjenesten er ikke tilgjengelig for øyeblikket, prøv igjen senere";
      html += "</div>";
      $(".tommekalender-dates").html(html);
    }

    // SMS
    $("#tommekalender-sms-form").submit(function (e) {
      e.preventDefault();
      // return false;
      if (
        $("#tommekalender-sms-mobilnummer").val() != "" &&
        $("#tommekalender-sms-time").val() != "" &&
        $("#tommekalender-address").val() != ""
      ) {
        $("#tommekalender-sms-form .loading").addClass("active");
        $("#tommekalender-sms-button")
          .addClass("disabled")
          .attr("disabled", "disabled");

        var data = {
          action: "send_sms",
          security: ajax_object.ajax_nonce,
          number: $("#tommekalender-sms-mobilnummer").val(),
          time: $("#tommekalender-sms-time").val(),
          address:
            $("#tommekalender-address").val() +
            " " +
            $("#tommekalender-number").val(),
          kommunenummeret: $("#tommekalender-kommunenummeret").val(),
        };

        console.log(data);

        currentRequest = jQuery
          .ajax({
            type: "POST",
            data: data,
            url: ajax_object.ajax_url,
            cache: false,
            beforeSend: function () {},
          })
          .done(function (response) {
            console.log(response);
            $("#tommekalender-sms").hide();
            $("#tommekalender-sms-form .loading").removeClass("active");
            $("#tommekalender-sms-button")
              .removeClass("disabled")
              .prop("disabled", false);
            if (response !== "true") {
              $("#tommekalender-sms-error").fadeIn();
            } else {
              $("#tommekalender-sms-message").fadeIn();
            }
          });
      }
      return false;
    });
  }

  $("#tommekalender-dates").appendTo("body");

})(jQuery);